// frontend/src/hooks/useOnlineStatus.js
// Standard browser online/offline signal (navigator.onLine + the
// online/offline window events). Deliberately simple: this app never caches
// or shows financial data offline at all (see services/api.js's request
// interceptor and sw.js's network-only /api/* handling), so there's no
// "stale data" failure mode to guard against with a fancier heartbeat/ping
// check — the only job here is showing the user a clear, immediate signal.
import { useState, useEffect } from 'react';

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(
    typeof navigator === 'undefined' ? true : navigator.onLine
  );

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return isOnline;
}
